<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <form [formGroup]="summaryForm" (ngSubmit)="onSubmit()">
                <div class="row mb-3 py-2">
                    <div class="col-md-4">
                        <input-field [label]="'Project Starting Date'" [inputFormControl]="projectStartDateControl"
                            type="date" [placeholder]="'YYYY-MM-DD'">
                        </input-field>
                    </div>
                    <div class="col-md-4">
                        <select-field [label]="'Status'" [selectFormControl]="projectStatusControl"
                            [options]="statusOptions">
                        </select-field>
                    </div>
                    <div class="col-md-4">
                        <label class="fw-bold">Current Progress</label>
                        <div class="progress-circle-container">
                            <div class="progress-circle">
                                <div class="progress-circle-value"
                                    [ngStyle]="{'color': activeView === 'done' ? '#28a745' : '#6c757d'}">
                                    <span class="progress-value">{{progressValue}}%</span>
                                    <span class="progress-text">{{ activeView === 'done' ? 'Done' : 'To Do' }}</span>
                                </div>
                                <svg viewBox="0 0 36 36" class="circular-chart" role="img"
                                    aria-label="Project progress">
                                    <path class="circle-bg"
                                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                    <path class="circle" [attr.stroke]="activeView === 'done' ? '#28a745' : '#6c757d'"
                                        [attr.stroke-dasharray]="progressValue + ', 100'"
                                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                                </svg>
                            </div>
                            <div class="progress-legend d-flex flex-column align-items-center">
                                <div class="btn-group mt-2" role="group" aria-label="Toggle progress view">
                                    <button type="button" class="btn"
                                        [ngClass]="{'btn-success': activeView === 'done', 'btn-outline-success': activeView !== 'done'}"
                                        (click)="toggleProgress('done')">
                                        Done ({{progressDone}}%)
                                    </button>
                                    <button type="button" class="btn"
                                        [ngClass]="{'btn-secondary': activeView === 'todo', 'btn-outline-secondary': activeView !== 'todo'}"
                                        (click)="toggleProgress('todo')">
                                        To Do ({{progressToDo}}%)
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3 g-3 summary-textareas">
                    <div [ngClass]="canViewProgressNote ? 'col-12 col-md-6 col-xl-3' : 'col-12 col-md-4'">
                        <textarea-field [label]="'Proposal Summary'" [placeholder]="'Proposal Summary'" [textareaFormControl]="proposalSummaryControl"
                            [height]="150">
                        </textarea-field>
                    </div>
                    <div [ngClass]="canViewProgressNote ? 'col-12 col-md-6 col-xl-3' : 'col-12 col-md-4'">
                        <textarea-field [label]="'Proposal Description'" [placeholder]="'Proposal Description'" [textareaFormControl]="proposalDescriptionControl"
                            [height]="150">
                        </textarea-field>
                    </div>
                    <div [ngClass]="canViewProgressNote ? 'col-12 col-md-6 col-xl-3' : 'col-12 col-md-4'">
                        <textarea-field [label]="'Preliminary Info from Customer'" [placeholder]="'Preliminary Info from Customer'"
                            [textareaFormControl]="preliminaryInfoControl" [height]="150">
                        </textarea-field>
                    </div>
                    @if (canViewProgressNote) {
                    <div class="col-12 col-md-6 col-xl-3">
                        <textarea-field [label]="'Progress Note'" [placeholder]="'Progress Note'"
                            [textareaFormControl]="progressNoteControl" [height]="150">
                        </textarea-field>
                    </div>
                    }
                </div>

                @if (canViewReviewedCheckbox) {
                <div class="row mb-3">
                    <div class="col-md-6">
                        <div class="reviewed-project-wrapper">
                            <input type="checkbox" id="reviewedProject" [formControl]="reviewedProjectControl"
                                [title]="canModifyReviewedCheckbox && !canToggleReviewedProject()
                                    ? 'All testlist steps must be Passed before you can confirm the review'
                                    : null">
                            <label for="reviewedProject">Reviewed entire project</label>
                        </div>
                    </div>
                </div>
                }

                @if (canViewInspectors) {
                <div class="row mb-3">
                    <div class="col-md-4">
                        <label class="fw-bold">Inspectors</label>
                        <div class="inspector-section">
                            @if (canModifyInspectors) {
                            <div class="inspector-controls mb-2">
                                <select-field
                                    [selectFormControl]="inspectorSelectControl"
                                    [options]="inspectorOptions"
                                    [readonly]="isLoadingAvailableInspectors || isLoadingInspectors"
                                    class="inspector-select">
                                </select-field>
                                    <button type="button"
                                    class="btn btn-primary btn-inspector ms-2"
                                    (click)="addInspector()"
                                    [disabled]="!inspectorSelectControl.value || isLoadingInspectors || isLoadingAvailableInspectors">
                                        <i class="bi bi-plus"></i>
                                    Add Inspector
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="inspector-table mt-4">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>NAME</th>
                                            <th class="text-center" style="width: 100px">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (inspector of inspectors; track trackByInspector($index, inspector); let i = $index) {
                                            <tr>
                                                <td>{{ getInspectorName(inspector) }}</td>
                                                <td class="text-center">
                                                    @if (canModifyInspectors) {
                                                        <button type="button"
                                                            class="btn btn-sm btn-danger"
                                                            (click)="onTableAction({action: 'delete', item: inspector})"
                                                            [disabled]="isLoadingInspectors">
                                                            <i class="bi bi-trash"></i>
                                                        </button>
                                                    }
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                        </div>
                    </div>
                </div>
                }
            </form>
        </div>
    </div>
    @if (canViewNotes) {
    <div class="row my-2">
        <div class="col-md-12">
            <notes-customers-form [readonlyCustomerNotes]="false" [customer]="projectNotes"
                [noteServiceMethod]="projectsService" [addNoteMethod]="'createSummaryNotes'"
                [deleteNoteMethod]="'deleteSummaryNotes'" [sectionAttribute]="'projectId'">
            </notes-customers-form>

            <projects-history-logs class="d-block mt-3" [projectId]="projectId"></projects-history-logs>
        </div>
    </div>
    }
</div>